import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseReportService } from '@app/api/api-services/base-report.service';
import { ConversationsReportFiltersApiModel } from '@app/api/api-models/program/reports/mentoring/conversations/ConversationsReportFiltersApiModel';
import { ConversationsReportRequestApiModel } from '@app/api/api-models/program/reports/mentoring/conversations/ConversationsReportRequestApiModel';
import { ConversationsReportApiModel } from '@app/api/api-models/program/reports/mentoring/conversations/ConversationsReportApiModel';

@Injectable()
export class ConversationsReportService extends BaseReportService<
  ConversationsReportFiltersApiModel,
  ConversationsReportRequestApiModel,
  ConversationsReportApiModel
> {
  public readonly apiUrl = 'mt-reports/conversations';

  public getReport(request: ConversationsReportRequestApiModel): Observable<ConversationsReportApiModel> {
    return super.getReport(request.serialize());
  }
}
